module.exports = __webpack_public_path__ + "img/app6.f69c2fec.png";